import React from "react";
import { FaEdit, FaBan, FaPrint } from "react-icons/fa";
import StatusBadge from "./StatusBadge";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const BookingsTable = ({ bookings, onEdit, onCancel, onReprint }) => {
  const exportToExcel = () => {
    const data = bookings.map((b) => ({
      BookingID: b.BookingCode,
      Name: b.FullName,
      Date: new Date(b.EventDate).toLocaleDateString(),
      Venue: b.Hall,
      Guests: b.Guests,
      Status: b.Status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(fileData, "banquet-bookings.xlsx");
  };

  return (
    <div className="bg-white shadow-2xl rounded-3xl overflow-hidden">
      {/* HEADER BAR */}
      <div className="flex justify-between items-center p-4 border-b">
        {/* <h2 className="font-semibold text-lg">Bookings</h2> */}
        <p>{""}</p>

        <button
          onClick={exportToExcel}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-lg text-sm"
        >
          {/* <FaFileExcel /> */}
          .xlsx
        </button>
      </div>

      {/* TABLE WRAPPER (mobile scroll) */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[700px]">
          <thead className="bg-gradient-to-r from-blue-600 to-emerald-500 text-white">
            <tr>
              <th className="px-4 py-3 text-left">Booking ID</th>
              <th className="px-4 py-3 text-left">Name</th>
              <th className="px-4 py-3 text-center">Date</th>
              <th className="px-4 py-3 text-center">Venue</th>
              <th className="px-4 py-3 text-center">Guests</th>
              <th className="px-4 py-3 text-center">Status</th>
              <th className="px-4 py-3 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {bookings.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-500">
                  No bookings found.
                </td>
              </tr>
            )}

            {bookings.map((b) => (
              <tr
                key={b.Id}
                className="border-b hover:bg-emerald-50 transition"
              >
                <td className="px-4 py-3 font-semibold">{b.BookingCode}</td>

                <td className="px-4 py-3">{b.FullName}</td>

                <td className="px-4 py-3 text-center">
                  {new Date(b.EventDate).toLocaleDateString('en-GB')}
                </td>

                <td className="px-4 py-3 text-center">{b.Hall || "-"}</td>

                <td className="px-4 py-3 text-center">{b.Guests}</td>

                <td className="px-4 py-3 text-center">
                  <div className="flex justify-center">
                    <StatusBadge date={b.EventDate} status={b.BookingStatus} />
                  </div>
                </td>

                <td className="px-4 py-3">
                  <div className="flex justify-center items-center gap-3">
                    {/* REPRINT */}
                    <button
                      onClick={() => onReprint(b.Id)}
                      className="text-green-600 hover:text-green-800 text-lg"
                      title="Reprint Slip"
                    >
                      <FaPrint />
                    </button>

                    <button
                      onClick={() => onEdit(b.Id)}
                      className="text-blue-500 hover:text-blue-700 text-lg"
                      title="Edit Booking"
                    >
                      <FaEdit />
                    </button>

                    {/* CANCEL */}
                    {b.Status !== "Cancelled" && (
                      <button
                        onClick={() => onCancel(b.Id)}
                        className="text-yellow-500 hover:text-yellow-700 text-lg transition"
                        title="Cancel Booking"
                      >
                        <FaBan />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BookingsTable;
